import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { ChangePasswordModal } from '../../../auth/components/ChangePasswordModal'

export const CustomButton = ({
  isSubmitting,
  isValid,
  isAcceptTerms,
  buttonText,
  loading,
  isAcceptTermsPresent,
  width,
  margin,
  buttonColor,
  buttonTextColor,
  show,
  handleClose,
  isModal,
  imgName,
  isSkipButton,
  widthLoading,
  height,
  marginButtom,
  onSubmit,
  onSkip,
  isdisable,
  disable,
}: {
  isSubmitting?: boolean
  isValid?: boolean
  isAcceptTerms?: boolean
  buttonText: string
  loading?: boolean
  isAcceptTermsPresent?: boolean
  width?: number
  margin?: string
  buttonColor?: string
  buttonTextColor?: string
  show?: boolean
  handleClose?: () => void
  isModal?: boolean
  imgName?: string
  isSkipButton?: boolean
  widthLoading?: number
  height?: number
  marginButtom?: string
  onSubmit?: () => void
  onSkip?: () => void
  isdisable?: boolean
  disable?: boolean
}) => {
  const { formatMessage } = useIntl()
  const [showModal, setShowModal] = useState(false)

  return (
    <div
      className={`w-100 w-md-auto d-grid ${marginButtom ? marginButtom : 'mb-10'} ${margin ? margin : ''}
      }`}
    >
      {isModal ? (
        <button
          type='button'
          onClick={() => setShowModal(true)}
          className={`btn ${buttonColor ? buttonColor : 'bg-primary text-white'} custom-button-property ${height ? `h-md-${height}px` : ''
            } `}
        >
          <span className={`${buttonTextColor ? buttonTextColor : 'indicator-label'}`}>{buttonText}</span>
        </button>
      ) : isSkipButton ? (
        <button
          type='button'
          onClick={async () => {
            if (onSkip) {
              await onSkip()
            }
          }}
          className={`btn ${buttonColor ? buttonColor : 'bg-primary text-white'} custom-button-property ${height ? `h-md-${height}px` : ''
            }`}
        >
          <span className='indicator-label'>{buttonText}</span>
        </button>
      ) : (
        <button
          type='submit'
          onClick={onSubmit}
          className={`btn ${margin} ${buttonColor ? buttonColor : 'bg-primary text-white'
            } custom-button-property ${height ? `h-md-${height}px` : ''}`}
          disabled={
            isSubmitting ||
            !isValid ||
            (!isAcceptTerms && isAcceptTermsPresent) ||
            isdisable ||
            disable
          }
        >
          {!loading && <span className='indicator-label font-size-13 p-0'>{buttonText}</span>}
          {loading && (
            <span className='indicator-label font-size-13 p-0'>
              {formatMessage({ id: 'Please wait...' })}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      )}

      <ChangePasswordModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        setShowModal={setShowModal}
      />
    </div>
  )
}
